// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"ba9ae2b5","453":"4209e644","498":"a54c9da8","640":"d40c832f","766":"3746101b","940":"276bdeae"}[chunkId] + ".chunk.js";
};